import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { USER_LOCALSTORAGE_KEY } from "../../../../shared/const/localstorage";
import {homeworkErrors, homeworkSuccess} from "../../slice/homework/homeworkResponseStudent";

export const fetchSubmitHomework = createAsyncThunk(
    "homework/submitHomework",
    async ({ homeworkAnswerData }: { homeworkAnswerData: FormData }, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);

            const response = await axios.post("/api/student/homework-answer", homeworkAnswerData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data.success) {
                thunkAPI.dispatch(homeworkSuccess(response.data))
            } else {
                thunkAPI.dispatch(homeworkErrors(response.data.error))
            }
            return response.data;
        } catch (error) {
            // Обработка ошибок
            console.error("Произошла ошибка:", error);
            return thunkAPI.rejectWithValue("error");
        }
    }
);
